<template>
    <div style="margin-top: 20px" class="internalCommsInfo">
        <el-form style="width: 100%">
            <div class="el-table el-table--fit el-table--border" style="100%">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td v-field-lbl="'departStatus'" class="el-table__cell tdcont tdw83" colspan="6">部门办理情况</td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdw83 internalCommsInfo_table" colspan="6" style="padding: 0 !important">
                                    <el-table :data="tableData" style="width: 100%">
                                        <el-table-column :label="$tx('fields.index', '序号')" type="index" width="50" align="center"></el-table-column>
                                        <el-table-column prop="deptName" :label="$tx('gwgl.components.fields.deptName', '部门名称')" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                                        <el-table-column prop="signingTime" :label="$tx('gwgl.components.fields.signingTime', '签收时间')" width="135" align="center" :show-overflow-tooltip="true">
                                            <template slot-scope="scope">
                                                <div>{{ scope.row.signingTime | timeFormat }}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="internalCommsContent" :label="$tx('gwgl.components.fields.internalCommsContent', '回复内容')" align="left" :show-overflow-tooltip="true"></el-table-column>
                                        <el-table-column prop="creator" :label="$tx('gwgl.components.fields.creator', '经办人')" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
                                        <el-table-column prop="createTime" :label="$tx('gwgl.components.fields.createTime', '回复时间')" width="135" align="center" :show-overflow-tooltip="true">
                                            <template slot-scope="scope">
                                                <div>{{ scope.row.signingTime | timeFormat }}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="address" :label="$tx('gwgl.components.fields.attachs', '附件')" width="200" align="center">
                                            <template slot-scope="scope">
                                                <div v-for="item in scope.row.passenger.attachments" :key="item.id">
                                                    <el-link @click="fileClick(item)">{{ item.fileName }}</el-link>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY-MM-DD HH:mm') : ''
        }
    },
    props: {
        vo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'components',
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getQueryData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        getQueryData() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: [{ compare: '=', field: 'applyId', merge: true, value: this.vo.id }],
                url: 'gwgl/internalCommsInfo/querydata'
            }).then((res) => {
                if (res.code == 'success') {
                    this.tableData = res.body.listdata
                } else {
                    this.$alert(res.message, { type: 'warning' })
                }
            })
        },
        fileClick(file) {
            window.open(`/apigw/gwgl/internalComms/downloadById?inline=true&attachIds=${file.id}&topdf=true&httpPort=${location.port}`)
        }
    }
}
</script>

<style scoped lang="scss">
.wflow-container .internalCommsInfo .el-form .internalCommsInfo_table .el-table::before {
    background-color: #fff !important;
}
.wflow-container .internalCommsInfo .el-form .internalCommsInfo_table .el-table::after {
    background-color: #fff !important;
}
.wflow-container .internalCommsInfo /deep/ .el-form .el-table.el-table--border td:last-child {
    border-right: none;
}
</style>
